import React, { useState } from "react";

/** Dashed +/- fold — same interaction as schedule Visit time point sections */
export default function UserFormCollapsible({
  title,
  defaultOpen = false,
  children,
  className = "",
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section
      className={`user-form-collapsible${open ? " is-open" : ""} ${className}`.trim()}
    >
      <div className="user-form-collapsible__head">
        <button
          type="button"
          className="user-form-collapsible__toggle"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          <i
            className={`fas ${open ? "fa-minus-circle" : "fa-plus-circle"}`}
            aria-hidden
          />
          <span>{title}</span>
        </button>
      </div>
      {open ? (
        <div className="user-form-collapsible__body">{children}</div>
      ) : null}
    </section>
  );
}
